import Swal from "sweetalert2";

export const showErrorAlert = (message: string) => {
    Swal.fire({
        icon: "error",
        title: "Error",
        text: message,
    });
};

export const showSuccessAlert = (message: string) => {
    Swal.fire({
        icon: "success",
        title: "Success",
        text: message,
    });
};

export const showWarningAlert = (message: string) => {
    Swal.fire({
        icon: "warning",
        title: "Warning",
        text: message,
    });
};
